<template>
  <v-container class="white black--text" id="complaint-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <!-- header -->
    <div class="header d-flex flex-column align-center">
      <p class="mb-0">Reno Police Department Complaint Form</p>
      <p class="blue--text">Reno Police Department Formulario de queja</p>
    </div>

    <div class="intro">
      <p>
        Thank you for expressing interest in the Reno Police Department. We are
        very concerned that our citizens receive the best law enforcement
        possible and value your comments or complaints. Anything you tell us
        here will be provided directly to the Chief of Police for appropriate
        action.
      </p>
      <p class="blue--text">
        Gracias por expresar interés en el Departamento de Policía de Reno. Nos
        preocupamos mucho en que nuestros ciudadanos reciban el mejor servicio
        de la ley posible y valoramos sus comentarios o quejas. Cualquier cosa
        que nos diga aquí se le entregará directamente al Jefe de Policía para
        que se tome una acción apropiada.
      </p>
    </div>

    <!-- instruction list -->
    <div class="inst-list">
      <span>Instructions/</span>
      <span class="blue--text">Instrucciones:</span>

      <ol>
        <li>
          <p class="mb-0">
            Form is to be completed by the person making the complaint.
          </p>
          <p class="blue--text">
            La forma o formulario debe completar la persona que hace el la
            queja.
          </p>
        </li>
        <li>
          <p class="mb-0">Please be as specific and as detailed as possible.</p>
          <p class="blue--text">
            Por favor sea específico/especifica y lo más detallado que sea
            posible.
          </p>
        </li>
        <li>
          <p class="mb-0">
            Click/Tap the Submit Button to submit the form to the RPD.
          </p>

          <p class="blue--text">
            Haga clic o toque el botón Enviar para enviar el formulario al RPD.
          </p>
        </li>
        <li>
          <p class="mb-0">
            Click/Tap the Print Button to print the form for your records.
          </p>
          <p style="font-size: small">
            (Print button will appear after you submit)
          </p>
          <p class="blue--text mb-0">
            Haga clic o toque el botón Imprimir para imprimir el formulario para
            sus registros.
          </p>
          <p class="blue--text" style="font-size: small">
            (El botón Imprimir aparecerá después de enviar)
          </p>
        </li>
      </ol>
    </div>
    <hr />
    <br />

    <!-- Form -->
    <div id="full">
      <v-form id="full_form" ref="form">
        <!-- COMPLAINANT INFORMATION -->
        <v-expansion-panels class="citizen-info-coll">
          <v-expansion-panel popout class="mt-2" width="100%">
            <v-expansion-panel-header color="#708e92" class="white--text">
              <template v-slot:actions>
                <v-icon color="white"> $expand </v-icon>
              </template>
              <p class="mb-0">
                CITIZEN/COMPLAINANT INFORMATION <br /><br />INFORMACIÓN DEL
                CIUDADANO/PERSONA QUE REALIZA LA QUEJA
              </p>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              eager
              id="content1"
              class="grey lighten-5"
            >
              <v-container>
                <!-- :rules="[rules.required, rules.namelength60]" -->
                <v-row>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="last_name"
                      name="last_name"
                      maxlength="60"
                      v-model="form.last_name"
                      label="Last Name/Apellido"
                      :rules="[rules.required, rules.namelength60]"
                      ref="last_name"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[rules.required, rules.namelength60]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="first_name"
                      name="first_name"
                      maxlength="60"
                      v-model="form.first_name"
                      label="First Name/Primer Nombre"
                      :rules="[rules.required, rules.namelength60]"
                      ref="first_name"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[rules.namelength1]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="mi"
                      name="mi"
                      maxlength="1"
                      v-model="form.mi"
                      label="Middle Initial/Inicial del Segundo Nombre "
                      v-mask="'A'"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[date_is_valid_rng]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      placeholder="##/##/####"
                      id="DtOBrth"
                      name="DtOBrth"
                      v-model="form.DtOBrth"
                      label="Date of Birth/Fecha de Nacimiento"
                      v-mask="'##/##/####'"
                      :rules="[date_is_valid_rng]"
                      ref="dob"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="home_phn"
                      name="home_phn"
                      maxlength="12"
                      v-model="form.home_phn"
                      label="Home Phone/Teléfono de la Casa"
                      v-mask="'###-###-####'"
                      :rules="[rules.required]"
                      ref="home_phn"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[rules.required]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="work_phn"
                      name="work_phn"
                      maxlength="12"
                      v-model="form.work_phn"
                      label="Work Phone/Teléfono del Trabajo"
                      v-mask="'###-###-####'"
                      :rules="[rules.required]"
                      ref="work_phn"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="phn_ext"
                      name="phn_ext"
                      maxlength="5"
                      v-model="form.work_phn_ext"
                      label="Work Phone Extension/Teléfono del Trabajo Extensión"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="other_phn"
                      name="other_phn"
                      maxlength="12"
                      v-model="form.oth_phn"
                      v-mask="'###-###-####'"
                      label="Other Contact Number/Otro Número de Contacto"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[rules.required]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="address"
                      name="address"
                      maxlength="120"
                      v-model="form.address"
                      label="Address/Dirección"
                      :rules="[rules.required]"
                      ref="address"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="city"
                      name="city"
                      maxlength="120"
                      v-model="form.city"
                      label="City/Ciudad"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-select
                      id="state"
                      name="state"
                      class="state-adj"
                      item-text="name"
                      item-value="abbreviation"
                      :items="states"
                      v-model="form.state"
                      label="State/Estado"
                      dense
                      attach
                    ></v-select>
                    <!-- <v-text-field
                      id="state"
                      name="state"
                      maxlength="2"
                      v-model="form.state"
                      label="State/Estado"
                    ></v-text-field> -->
                  </v-col>
                  <!-- :rules="[rules.namelength5]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="zip"
                      name="zip"
                      maxlength="5"
                      v-model="form.zip"
                      label="Zip/Código Postal"
                      v-mask="'#####'"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[rules.required, rules.email]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="email"
                      name="email"
                      maxlength="120"
                      v-model="form.email"
                      label="Email/Correo Electrónico"
                      :rules="[rules.required, rules.email]"
                      ref="email"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- Officer(s) involved -->
        <v-expansion-panels class="officer-inv">
          <v-expansion-panel popout class="mt-2" width="100%">
            <v-expansion-panel-header color="#708e92" class="white--text">
              <template v-slot:actions>
                <v-icon color="white"> $expand </v-icon>
              </template>
              <p class="mb-0">
                OFFICER(S) INVOLVED <br /><br />OFICIAL (ES) IMPLICADOS
              </p>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager class="grey lighten-5">
              <v-container>
                <v-row>
                  <!-- :rules="[rules.required]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="officers1_name"
                      name="officers1_name"
                      maxlength="120"
                      v-model="form.officers1_name"
                      label="Officer’s Name/Nombre del Oficial"
                      :rules="[rules.required]"
                      ref="officers1_name"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[rules.required]" -->
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers1_badge"
                      name="officers1_badge"
                      maxlength="6"
                      v-model="form.officers1_badge"
                      label="Badge No./ No. de Placa"
                      :rules="[rules.required]"
                      ref="officers1_badge"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers1_car_no"
                      name="officers1_car_no"
                      maxlength="20"
                      v-model="form.officers1_car_no"
                      label="Car No./No. de Vehículo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="officers2_name"
                      name="officers2_name"
                      maxlength="120"
                      v-model="form.officers2_name"
                      label="Officer’s Name/Nombre del Oficial"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers2_badge"
                      name="officers2_badge"
                      maxlength="6"
                      v-model="form.officers2_badge"
                      label="Badge No./ No. de Placa"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers2_car_no"
                      name="officers2_car_no"
                      maxlength="20"
                      v-model="form.officers2_car_no"
                      label="Car No./No. de Vehículo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="officers3_name"
                      name="officers3_name"
                      maxlength="120"
                      v-model="form.officers3_name"
                      label="Officer’s Name/Nombre del Oficial"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers3_badge"
                      name="officers3_badge"
                      maxlength="6"
                      v-model="form.officers3_badge"
                      label="Badge No./ No. de Placa"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers3_car_no"
                      name="officers3_car_no"
                      maxlength="20"
                      v-model="form.officers3_car_no"
                      label="Car No./No. de Vehículo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="officers4_name"
                      name="officers4_name"
                      maxlength="120"
                      v-model="form.officers4_name"
                      label="Officer’s Name/Nombre del Oficial"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers4_badge"
                      name="officers4_badge"
                      maxlength="6"
                      v-model="form.officers4_badge"
                      label="Badge No./ No. de Placa"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers4_car_no"
                      name="officers4_car_no"
                      maxlength="20"
                      v-model="form.officers4_car_no"
                      label="Car No./No. de Vehículo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="officers5_name"
                      name="officers5_name"
                      maxlength="120"
                      v-model="form.officers5_name"
                      label="Officer’s Name/Nombre del Oficial"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers5_badge"
                      name="officers5_badge"
                      maxlength="6"
                      v-model="form.officers5_badge"
                      label="Badge No./ No. de Placa"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers5_car_no"
                      name="officers5_car_no"
                      maxlength="20"
                      v-model="form.officers5_car_no"
                      label="Car No./No. de Vehículo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="officers6_name"
                      name="officers6_name"
                      maxlength="120"
                      v-model="form.officers6_name"
                      label="Officer’s Name/Nombre del Oficial"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers6_badge"
                      name="officers6_badge"
                      maxlength="6"
                      v-model="form.officers6_badge"
                      label="Badge No./ No. de Placa"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="officers6_car_no"
                      name="officers6_car_no"
                      maxlength="20"
                      v-model="form.officers6_car_no"
                      label="Car No./No. de Vehículo"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- WITNESS INFORMATION -->
        <v-expansion-panels class="citizen-info-coll">
          <v-expansion-panel popout class="mt-2" width="100%">
            <v-expansion-panel-header eager color="#708e92" class="white--text">
              <template v-slot:actions>
                <v-icon color="white"> $expand </v-icon>
              </template>
              <p class="mb-0">
                WITNESS INFORMATION <br /><br />INFORMACIÓN DEL TESTIGO(S)
              </p>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager class="grey lighten-5">
              <v-container>
                <v-row class="witness-info">
                  <!-- wit 1 -->
                  <v-col cols="12" md="12" lg="12">
                    <h4 class="mb-4 text-decoration-underline">Witness 1</h4>
                  </v-col>
                  <!-- :rules="[rules.required]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit1_last_name"
                      name="wit1_last_name"
                      maxlength="60"
                      v-model="form.wit1_last_name"
                      label="Last Name/Apellido"
                      :rules="[rules.required]"
                      ref="wit1_last_name"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[rules.required]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit1_first_name"
                      name="wit1_first_name"
                      maxlength="60"
                      v-model="form.wit1_first_name"
                      label="First Name/Primer Nombre"
                      :rules="[rules.required]"
                      ref="wit1_first_name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" lg="6">
                    <v-text-field
                      id="wit1_mi"
                      name="wit1_mi"
                      maxlength="1"
                      v-model="form.wit1_mi"
                      label="Middle Initial/Inicial del Segundo Nombre "
                      v-mask="'A'"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit1_phn"
                      name="wit1_phn"
                      maxlength="12"
                      v-model="form.wit1_phn"
                      label="Home Phone/Teléfono de la Casa"
                      v-mask="'###-###-####'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit1_address"
                      name="wit1_address"
                      maxlength="120"
                      v-model="form.wit1_address"
                      label="Address/Dirección"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit1_city"
                      name="wit1_city"
                      maxlength="120"
                      v-model="form.wit1_city"
                      label="City/Ciudad"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-select
                      id="state"
                      name="state"
                      class="state-adj"
                      item-text="name"
                      item-value="abbreviation"
                      :items="states"
                      v-model="form.wit1_state"
                      label="State/Estado"
                      dense
                      attach
                    ></v-select>
                    <!-- <v-text-field
                      id="wit1_state"
                      name="wit1_state"
                      maxlength="2"
                      v-model="form.wit1_state"
                      label="State/Estado"
                    ></v-text-field> -->
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit1_zip"
                      name="wit1_zip"
                      maxlength="5"
                      v-model="form.wit1_zip"
                      label="Zip/Código Postal"
                      v-mask="'#####'"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[rules.required]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit1_email"
                      name="wit1_email"
                      maxlength="120"
                      v-model="form.wit1_email"
                      label="Email/Correo Electrónico"
                      :rules="[rules.required, rules.email]"
                      ref="wit1_email"
                    ></v-text-field>
                  </v-col>
                  <hr />

                  <!-- wit 2 -->
                  <v-col cols="12" md="12" lg="12">
                    <h4 class="mb-4 text-decoration-underline">Witness 2</h4>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit2_last_name"
                      name="wit2_last_name"
                      maxlength="60"
                      v-model="form.wit2_last_name"
                      label="Last Name/Apellido"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit2_first_name"
                      name="wit2_first_name"
                      maxlength="60"
                      v-model="form.wit2_first_name"
                      label="First Name/Primer Nombre"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit2_mi"
                      name="wit2_mi"
                      maxlength="1"
                      v-model="form.wit2_mi"
                      label="Middle Initial/Inicial del Segundo Nombre "
                      v-mask="'A'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit2_phn"
                      name="wit2_phn"
                      maxlength="12"
                      v-model="form.wit2_phn"
                      label="Home Phone/Teléfono de la Casa"
                      v-mask="'###-###-####'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit2_address"
                      name="wit2_address"
                      maxlength="120"
                      v-model="form.wit2_address"
                      label="Address/Dirección"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit2_city"
                      name="wit2_city"
                      maxlength="120"
                      v-model="form.wit2_city"
                      label="City/Ciudad"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-select
                      id="state"
                      name="state"
                      class="state-adj"
                      item-text="name"
                      item-value="abbreviation"
                      :items="states"
                      v-model="form.wit2_state"
                      label="State/Estado"
                      dense
                      attach
                    ></v-select>
                    <!-- <v-text-field
                      id="wit2_state"
                      name="wit2_state"
                      maxlength="2"
                      v-model="form.wit2_state"
                      label="State/Estado"
                    ></v-text-field> -->
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit2_zip"
                      name="wit2_zip"
                      maxlength="5"
                      v-model="form.wit2_zip"
                      label="Zip/Código Postal"
                      v-mask="'#####'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit2_email"
                      name="wit2_email"
                      maxlength="120"
                      v-model="form.wit2_email"
                      label="Email/Correo Electrónico"
                      :rules="[rules.email]"
                      ref="wit2_email"
                    ></v-text-field>
                  </v-col>
                  <hr />

                  <!-- wit 3 -->
                  <v-col cols="12" md="12" lg="12">
                    <h4 class="mb-4 text-decoration-underline">Witness 3</h4>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit3_last_name"
                      name="wit3_last_name"
                      maxlength="60"
                      v-model="form.wit3_last_name"
                      label="Last Name/Apellido"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit3_first_name"
                      name="wit3_first_name"
                      maxlength="60"
                      v-model="form.wit3_first_name"
                      label="First Name/Primer Nombre"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit3_mi"
                      name="wit3_mi"
                      maxlength="1"
                      v-model="form.wit3_mi"
                      label="Middle Initial/Inicial del Segundo Nombre "
                      v-mask="'A'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit3_phn"
                      name="wit3_phn"
                      maxlength="12"
                      v-model="form.wit3_phn"
                      label="Home Phone/Teléfono de la Casa"
                      v-mask="'###-###-####'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit3_address"
                      name="wit3_address"
                      maxlength="120"
                      v-model="form.wit3_address"
                      label="Address/Dirección"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit3_city"
                      name="wit3_city"
                      maxlength="120"
                      v-model="form.wit3_city"
                      label="City/Ciudad"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-select
                      id="state"
                      name="state"
                      class="state-adj"
                      item-text="name"
                      item-value="abbreviation"
                      :items="states"
                      v-model="form.wit3_state"
                      label="State/Estado"
                      dense
                      attach
                    ></v-select>
                    <!-- <v-text-field
                      class="state-adj"
                      id="wit3_state"
                      name="wit3_state"
                      maxlength="2"
                      v-model="form.wit3_state"
                      label="State/Estado"
                    ></v-text-field> -->
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit3_zip"
                      name="wit3_zip"
                      maxlength="5"
                      v-model="form.wit3_zip"
                      label="Zip/Código Postal"
                      v-mask="'#####'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="wit3_email"
                      name="wit3_email"
                      maxlength="120"
                      v-model="form.wit3_email"
                      label="Email/Correo Electrónico"
                      :rules="[rules.email]"
                      ref="wit3_email"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- INCIDENT DETAILS/NATURE OF COMPLAINT -->
        <v-expansion-panels class="inc-detail-coll">
          <v-expansion-panel popout class="mt-2" width="100%">
            <v-expansion-panel-header color="#708e92" class="white--text">
              <template v-slot:actions>
                <v-icon color="white"> $expand </v-icon>
              </template>
              <p class="mb-0">
                INCIDENT DETAILS <br /><br />
                DETALLES DEL INCIDENTE
              </p>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager class="grey lighten-5">
              <v-container>
                <v-row class="inc-details">
                  <!-- incident details -->
                  <!-- :rules="[rules.required, date_is_valid_rng]" -->
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      placeholder="##/##/####"
                      id="incident_date"
                      name="incident_date"
                      v-model="form.incident_date"
                      label="Date of Incident/Fecha del Incidente"
                      v-mask="'##/##/####'"
                      :rules="[rules.required, date_is_valid_rng]"
                      ref="incident_date"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="incident_time"
                      name="incident_time"
                      maxlength="5"
                      v-model="form.incident_time"
                      label="Time of Incident/Tiempo del incidente"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="case_num"
                      name="case_num"
                      maxlength="8"
                      v-model="form.case_num"
                      label="RPD Case No/Caso Número de RPD "
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      id="location"
                      name="location"
                      maxlength="120"
                      v-model="form.location"
                      label="Location of Incident/Localización del incidente"
                    ></v-text-field>
                  </v-col>
                  <!-- :rules="[rules.required]" -->
                  <v-col cols="12" md="12" lg="12">
                    <label>NATURE OF COMPLAINT/NATURALEZA DE LA QUEJA</label>
                    <v-textarea
                      solo
                      class="mt-1"
                      id="narrative"
                      name="narrative"
                      maxlength="4000"
                      v-model="form.narrative"
                      :rules="[rules.required]"
                      ref="narrative"
                    ></v-textarea>
                    <!-- label="NATURE OF COMPLAINT/NATURALEZA DE LA
                    QUEJA/COMENTARIO" -->
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>
    </div>
    <!-- buttons -->

    <v-container>
      <v-row class="date-sig">
        <v-col cols="12" md="6" lg="6">
          <v-text-field
            placeholder="##/##/####"
            id="today_date"
            name="today_date"
            v-model="form.today_date"
            label="Today's Date/Fecha"
            v-mask="'##/##/####'"
            :rules="[rules.required, date_is_valid_rng]"
            ref="today_date"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col class="pa-0" cols="12">
          <v-checkbox
            class="mt-0"
            v-model="checkbox"
            label="As the person listed above, I acknowledge that I have read and understood the instructions and process for using this form. "
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-container>
    <div class="print-sub-buttons d-flex justify-space-around">
      <v-btn v-if="form.complaintId > 0" color="accent" @click="print"
        >Print</v-btn
      >
      <v-btn v-if="form.complaintId == 0" color="accent" @click="submit"
        >Submit</v-btn
      >
      <v-btn v-if="form.complaintId > 0" color="accent" @click="close"
        >Close</v-btn
      >
    </div>
  </v-container>
</template>

<!-- Style -->
<style lang="scss" scoped>
@import "../scss/site.scss";
#complaint-container {
  max-width: 768px;
}

/* 0 media q */
@media (min-width: 0px) {
  .header p {
    font-size: 1.2em;
  }

  .witness-info hr {
    width: 100%;
  }
}

/* 320 media q */
/* smartphones, iPhone, portrait 480x320 phones */
@media (min-width: 320px) {
}

/* 641 media q */
/* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
@media (min-width: 641px) {
  .header p {
    font-size: 1.75em;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .state-adj {
    position: relative;
    top: 18px;
    z-index: 1000;
  }
}
.v-list-item__content {
  position: relative;

  z-index: 1000;
}

/* 961 media q */
/* tablet, landscape iPad, lo-res laptops ands desktops */
@media (min-width: 961px) {
}

/* ipad lansdscape */
/* tablet, landscape iPad, lo-res laptops ands desktops */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */
/* big landscape tablets, laptops, and desktops */
@media (min-width: 1025px) {
  .header p {
    font-size: 2em;
  }
  #vapp {
    overflow-y: scroll !important ;
  }
}

/* 1281 media q */
/* hi-res laptops and desktops */
@media (min-width: 1281px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "complaint",
  mixins: [bus_common],
  data() {
    return {
      checkbox: false,
      rules: {
        required: (value) => !!value || "Required.",
        namelength60: (value) => value.length <= 60 || "Max 60 characters",
        namelength1: (value) => value.length <= 1 || "Max 1 characters",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return value.length == 0 || pattern.test(value) || "Invalid e-mail.";
        },
      },
      new_form_dev: {
        complaintId: 0,
        last_name: "Smith", //60
        first_name: "Bob", //60
        mi: "m", //1
        DtOBrth: "06/06/1950", //date
        home_phn: "111-111-1111", //12
        work_phn: "222-222-2222", //12
        work_phn_ext: "_phn_ext", //5
        oth_phn: "333-333-3333",
        address: "address", //120
        city: "city", //120
        state: "NV", //2
        zip: "11111", //5
        email: "jvonmolt@gmail.com", //120

        //Officers
        officers1_name: "officers1_name", //120
        officers1_badge: "1_badg", //6
        officers1_car_no: "officers1_car_no", //20
        officers2_name: "officers2_name",
        officers2_badge: "2_badg",
        officers2_car_no: "officers2_car_no",
        officers3_name: "officers3_name",
        officers3_badge: "3_badg",
        officers3_car_no: "officers3_car_no",
        officers4_name: "officers4_name",
        officers4_badge: "4_badg",
        officers4_car_no: "officers4_car_no",
        officers5_name: "officers5_name",
        officers5_badge: "5_badg",
        officers5_car_no: "officers5_car_no",
        officers6_name: "officers6_name",
        officers6_badge: "6_badg",
        officers6_car_no: "officers6_car_no",

        //witnesses
        wit1_last_name: "wit1_last_name",
        wit1_first_name: "wit1_first_name",
        wit1_mi: "1",
        wit1_phn: "111-111-1112",
        wit1_address: "wit1_address",
        wit1_city: "wit1_city",
        wit1_state: "NV",
        wit1_zip: "89501",
        wit1_email: "jvonmolt@gmail.com",

        wit2_last_name: "wit2_last_name",
        wit2_first_name: "wit2_first_name",
        wit2_mi: "2",
        wit2_phn: "111-111-1113",
        wit2_address: "wit2_address",
        wit2_city: "wit2_city",
        wit2_state: "NV",
        wit2_zip: "89503",
        wit2_email: "jvonmolt@gmail.com",

        wit3_last_name: "wit3_last_name",
        wit3_first_name: "wit3_first_name",
        wit3_mi: "3",
        wit3_phn: "111-111-1114",
        wit3_address: "wit3_address",
        wit3_city: "wit3_city",
        wit3_state: "NV",
        wit3_zip: "89504",
        wit3_email: "jvonmolt@gmail.com",

        wit4_last_name: "wit4_last_name",
        wit4_first_name: "wit4_first_name",
        wit4_mi: "4",
        wit4_phn: "wit4_phn",
        wit4_address: "wit4_address",
        wit4_city: "wit4_city",
        wit4_state: "4s",
        wit4_zip: "4_zip",
        wit4_email: "jvonmolt@gmail.com",

        wit5_last_name: "wit5_last_name",
        wit5_first_name: "wit5_first_name",
        wit5_mi: "5",
        wit5_phn: "wit5_phn",
        wit5_address: "wit5_address",
        wit5_city: "wit5_city",
        wit5_state: "5s",
        wit5_zip: "5_zip",
        wit5_email: "5_email",

        wit6_last_name: "wit6_last_name",
        wit6_first_name: "wit6_first_name",
        wit6_mi: "6",
        wit6_phn: "wit6_phn",
        wit6_address: "wit6_address",
        wit6_city: "wit6_city",
        wit6_state: "6s",
        wit6_zip: "wit6_zip",
        wit6_email: "6_email",

        //incident
        incident_date: "06/06/2024", //date
        incident_time: "14:00",
        case_num: "99-99999",
        location: "round the corner",
        narrative: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis
obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam
nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit,
tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit,
quia. Quo neque error repudiandae fuga? Ipsa laudantium molestias eos 
sapiente officiis modi at sunt excepturi expedita sint? Sed quibusdam
recusandae alias error harum maxime adipisci amet laborum. Perspiciatis 
minima nesciunt dolorem! Officiis iure rerum voluptates a cumque velit `,
        today_date: "06/06/1950",
        sig: "my signature",
      },
      new_form: {
        complaintId: 0,
        last_name: "", //60
        first_name: "", //60
        mi: "", //1
        DtOBrth: "", //date
        home_phn: "", //12
        work_phn: "", //12
        work_phn_ext: "", //5
        oth_phn: "", //12
        address: "", //120
        city: "", //120
        state: "", //2
        zip: "", //5
        email: "",

        officers1_name: "", //120
        officers1_badge: "", //6
        officers1_car_no: "", //20
        officers2_name: "",
        officers2_badge: "",
        officers2_car_no: "",
        officers3_name: "",
        officers3_badge: "",
        officers3_car_no: "",
        officers4_name: "",
        officers4_badge: "",
        officers4_car_no: "",
        officers5_name: "",
        officers5_badge: "",
        officers5_car_no: "",
        officers6_name: "",
        officers6_badge: "",
        officers6_car_no: "",

        wit1_last_name: "",
        wit1_first_name: "",
        wit1_mi: "",
        wit1_phn: "",
        wit1_address: "",
        wit1_city: "",
        wit1_state: "",
        wit1_zip: "",
        wit1_email: "",

        wit2_last_name: "",
        wit2_first_name: "",
        wit2_mi: "",
        wit2_phn: "",
        wit2_address: "",
        wit2_city: "",
        wit2_state: "",
        wit2_zip: "",
        wit2_email: "",

        wit3_last_name: "",
        wit3_first_name: "",
        wit3_mi: "",
        wit3_phn: "",
        wit3_address: "",
        wit3_city: "",
        wit3_state: "",
        wit3_zip: "",
        wit3_email: "",

        incident_date: "",
        incident_time: "",
        case_num: "",
        location: "",
        narrative: "",

        today_date: "",
        sig: "",
      },

      form: {
        complaintId: 0,
        last_name: "", //60
        first_name: "", //60
        mi: "", //1
        DtOBrth: "", //date
        home_phn: "", //12
        work_phn: "", //12
        work_phn_ext: "", //5
        oth_phn: "ot_phn", //12
        address: "", //120
        city: "", //120
        state: "", //2
        zip: "", //5
        email: "", //120

        officers1_name: "", //120
        officers1_badge: "", //6
        officers1_car_no: "", //20
        officers2_name: "",
        officers2_badge: "",
        officers2_car_no: "",
        officers3_name: "",
        officers3_badge: "",
        officers3_car_no: "",
        officers4_name: "",
        officers4_badge: "",
        officers4_car_no: "",
        officers5_name: "",
        officers5_badge: "",
        officers5_car_no: "",
        officers6_name: "",
        officers6_badge: "",
        officers6_car_no: "",

        wit1_last_name: "",
        wit1_first_name: "",
        wit1_mi: "",
        wit1_phn: "",
        wit1_address: "",
        wit1_city: "",
        wit1_state: "",
        wit1_zip: "",
        wit1_email: "",

        wit2_last_name: "",
        wit2_first_name: "",
        wit2_mi: "",
        wit2_phn: "",
        wit2_address: "",
        wit2_city: "",
        wit2_state: "",
        wit2_zip: "",
        wit2_email: "",

        wit3_last_name: "",
        wit3_first_name: "",
        wit3_mi: "",
        wit3_phn: "",
        wit3_address: "",
        wit3_city: "",
        wit3_state: "",
        wit3_zip: "",
        wit3_email: "",

        incident_date: "",
        incident_time: "",
        case_num: "",
        location: "",
        narrative: "",

        today_date: "",
        sig: "",
      },
      states: [
        { name: "Alabama", abbreviation: "AL" },
        { name: "Alaska", abbreviation: "AK" },
        { name: "Arizona", abbreviation: "AZ" },
        { name: "Arkansas", abbreviation: "AR" },
        { name: "California", abbreviation: "CA" },
        { name: "Colorado", abbreviation: "CO" },
        { name: "Connecticut", abbreviation: "CT" },
        { name: "Delaware", abbreviation: "DE" },
        { name: "Florida", abbreviation: "FL" },
        { name: "Georgia", abbreviation: "GA" },
        { name: "Hawaii", abbreviation: "HI" },
        { name: "Idaho", abbreviation: "ID" },
        { name: "Illinois", abbreviation: "IL" },
        { name: "Indiana", abbreviation: "IN" },
        { name: "Iowa", abbreviation: "IA" },
        { name: "Kansas", abbreviation: "KS" },
        { name: "Kentucky", abbreviation: "KY" },
        { name: "Louisiana", abbreviation: "LA" },
        { name: "Maine", abbreviation: "ME" },
        { name: "Maryland", abbreviation: "MD" },
        { name: "Massachusetts", abbreviation: "MA" },
        { name: "Michigan", abbreviation: "MI" },
        { name: "Minnesota", abbreviation: "MN" },
        { name: "Mississippi", abbreviation: "MS" },
        { name: "Missouri", abbreviation: "MO" },
        { name: "Montana", abbreviation: "MT" },
        { name: "Nebraska", abbreviation: "NE" },
        { name: "Nevada", abbreviation: "NV" },
        { name: "New Hampshire", abbreviation: "NH" },
        { name: "New Jersey", abbreviation: "NJ" },
        { name: "New Mexico", abbreviation: "NM" },
        { name: "New York", abbreviation: "NY" },
        { name: "North Carolina", abbreviation: "NC" },
        { name: "North Dakota", abbreviation: "ND" },
        { name: "Ohio", abbreviation: "OH" },
        { name: "Oklahoma", abbreviation: "OK" },
        { name: "Oregon", abbreviation: "OR" },
        { name: "Pennsylvania", abbreviation: "PA" },
        { name: "Rhode Island", abbreviation: "RI" },
        { name: "South Carolina", abbreviation: "SC" },
        { name: "South Dakota", abbreviation: "SD" },
        { name: "Tennessee", abbreviation: "TN" },
        { name: "Texas", abbreviation: "TX" },
        { name: "Utah", abbreviation: "UT" },
        { name: "Vermont", abbreviation: "VT" },
        { name: "Virginia", abbreviation: "VA" },
        { name: "Washington", abbreviation: "WA" },
        { name: "West Virginia", abbreviation: "WV" },
        { name: "Wisconsin", abbreviation: "WI" },
        { name: "Wyoming", abbreviation: "WY" },
      ],
    };
  },
  methods: {
    close() {
      this.$router.push("/");
    },
    submit() {
      //this.mrbreakpoint("val: " + this.$refs.form.validate());

      if (this.$refs.form.validate() == false) {
        let keys = [];
        for (let [key, value] of Object.entries(this.$refs)) {
          console.log(key.toString(), value.hasError);
        }
        this.show_loader(false);
        this.swall_it(
          "Form Status",
          "Please fix the red marked fields.",
          "warning",
          null,
          null
        );
        return true;
      }
      if (this.checkbox == false) {
        this.swall_it(
          "Form Status",
          "Please look at the check box at the bottom of the form and choose to agree with the statement if you wish to submit this form.",
          "warning",
          null,
          null
        );
        return true;
      }

      this.show_loader(true);

      var formIn = this.mno(this.form);
      formIn.apiname = "save_complaint";
      formIn.dob = formIn.DtOBrth;
      if (
        formIn.dob == "Invalid date" ||
        formIn.dob == "" ||
        formIn.dob == null
      ) {
        formIn.dob = "01/01/1924";
      }
      formIn.dob = this.format_date_sql(formIn.dob);
      formIn.incident_date = this.format_date_sql(formIn.incident_date);
      formIn.today_date = this.format_date_sql(formIn.today_date);
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          self.form = self.mno(data);
          self.form.today_date = this.format_date_us(new Date());
          self.form.DtOBrth = this.format_date_us(self.form.dob);
          self.form.incident_date = this.format_date_us(
            self.form.incident_date
          );

          self.form.narrative = self.replaceBrWithLineBreaks(
            self.form.narrative
          );

          this.swall_it(
            "Thank You",
            "Thank you for submitting your complaint form to the Internal Affairs office. Please allow 3-5 business days for your complaint to be reviewed and someone from Internal Affairs will contact you. <br> You may close this page or Print a Copy.<br><br> Gracias por enviar su formulario de queja a la oficina de Asuntos Internos. Por favor, espere de 3 a 5 días laborables para que su queja sea revisada y alguien de Asuntos Internos se pondrá en contacto con usted. <br> Puede cerrar esta página o imprimir una copia",
            "success",
            null,
            null
          );
          // this.$router.push("/");
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg.msg, "error", null, null);
        });
    },
    print() {
      let rnd1 = this.randomNum(1000, 9999);
      let rnd2 = this.randomNum(1000, 9999);
      let id = parseInt(
        rnd1.toString() + this.form.complaintId.toString() + rnd2.toString()
      );
      console.log(this.form.complaintId, id);
      window.open("/printform/print/?id=" + id);
    },
    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      document.getElementById("vapp").style.overflowY = "scroll";
      this.form = this.mno(this.new_form);
      this.form.today_date = this.format_date_us(new Date());
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
    // track page visits/
    console.log("banner mounted");
    // Build the payload
    const payload = {
      url: window.location.href,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };

    console.log("track: " + payload.url);

    // Post to your analytics endpoint
    fetch("/Analytics/Track", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }).catch((err) => {
      console.error("Analytics tracking failed:", err);
    });
  },
};
</script>
